import find from 'lodash.find';
import findIndex from 'lodash.findindex';
import { localStorage } from 'dibs-browser-storage';

const PDP_VISITS = 'pdpVisits';
const PDP_STORAGE_LIMIT = 200;
const PDP_MULTIPLE_VISITS_LIMIT = 2;

export const storePdpVisit = ({ itemId }) => {
    const pdpVisits = localStorage.getItem(PDP_VISITS) || [];
    const pdpIndex = findIndex(pdpVisits, itemId);
    if (pdpIndex !== -1) {
        //Removes pdp from visits array
        const pdp = pdpVisits.splice(pdpIndex, 1)[0];
        //Increases visits counter
        pdp[itemId] = pdp[itemId] + 1;
        //Inserts into front
        pdpVisits.unshift(pdp);
    } else {
        //Inserts into front new pdp if yet it was not visited
        pdpVisits.unshift({ [itemId]: 1 });
    }

    //Removes last pdp if length exceeds limit
    if (pdpVisits.length > PDP_STORAGE_LIMIT) {
        pdpVisits.pop();
    }

    localStorage.setItem(PDP_VISITS, pdpVisits);
};

export const wasPdpVisitedMultipleTimes = ({ itemId }) => {
    const pdpVisits = localStorage.getItem(PDP_VISITS);
    const pdp = find(pdpVisits, itemId);
    return pdp[itemId] >= PDP_MULTIPLE_VISITS_LIMIT;
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/MultiplePdpVisitsModal/multiplePdpVisitsModalHelpers.es.js